module.exports = __webpack_public_path__ + "static/media/filePDF.3f43df44.svg";